import React from "react";
import icons from "../../../../../assets/images/icons";
import { MESSAGE_SEND_ERROR } from "../../../constants/constants";
import { buildFrameBodyClassName, deriveChatMessageProps } from "../../../utils/deriveChatMessageProps";
import styles from "./ChatMessage.module.scss";
import ChatMessageBody from "./ChatMessageBody";
import OpponentAvatar from "./OpponentAvatar";

/**
 * Chat message Opponent/My (Figma 40004344:52778, 40004344:52777)
 * disco 디자인 v3.0.0 - 채팅 말풍선 (상대/내 메시지)
 * Code Connect: ChatMessage.figma.jsx
 */
function ChatMessage({
  className = "",
  type,
  senderName,
  time,
  body,
  avatarUrl,
  /** @deprecated imageUrls 우선 */
  imageUrl,
  imageUrls,
  imageThumbnailUrls,
  imageFileNames,
  fileAttachments,
  fileName,
  fileExtension,
  fileUrl,
  onDownload,
  onDownloadFile,
  onImageClick,
  content,
  status,
  grouped = false,
  readReceiptClass,
  readReceiptCount,
  onFailedRetry,
  onFailedDelete,
  onSaleCardClick,
  failReason,
}) {
  const {
    isMy,
    fileRows,
    hasFile,
    resolvedUrls,
    resolvedThumbnailUrls,
    resolvedImageNames,
    hasContent,
    isPending,
    isFailed,
    hasRenderableBody,
  } = deriveChatMessageProps({
    type,
    status,
    content,
    imageUrls,
    imageThumbnailUrls,
    imageUrl,
    imageFileNames,
    fileAttachments,
    fileName,
    fileExtension,
    fileUrl,
    body,
  });

  const frameBodyClassName = buildFrameBodyClassName(styles, isPending, isFailed);
  const receiptExtraClass =
    isMy && (readReceiptClass === "unread" || readReceiptClass === "read") ? ` ${readReceiptClass}` : "";

  const bodyEl = (
    <ChatMessageBody
      hasContent={hasContent}
      content={content}
      resolvedUrls={resolvedUrls}
      resolvedThumbnailUrls={resolvedThumbnailUrls}
      resolvedImageNames={resolvedImageNames}
      onImageClick={onImageClick}
      imageFallbackSrc={icons.messager?.imageThumbnail}
      hasFile={hasFile}
      fileRows={fileRows}
      onDownload={onDownload}
      onDownloadFile={onDownloadFile}
      body={body}
      onSaleCardClick={onSaleCardClick}
    />
  );

  const showPendingIcon = isMy && isPending && Boolean(icons.messager?.pending);
  const showFailedChrome = isMy && isFailed && hasRenderableBody;

  const renderBodyBlock = () => {
    if (showPendingIcon) {
      return (
        <div className={styles.myBubbleWithPendingRow}>
          <span className={styles.pendingIconWrap} aria-hidden>
            <img
              src={icons.messager.pending}
              alt=""
              className={styles.pendingIcon}
              width={16}
              height={16}
            />
          </span>
          <div className={frameBodyClassName}>{bodyEl}</div>
        </div>
      );
    }
    if (showFailedChrome) {
      return (
        <div className={styles.myFailedColumn}>
          <div className={styles.myFailedBubbleRow}>
            <div className={styles.failedActionBar}>
              <button
                type="button"
                className={styles.failedActionBtn}
                onClick={() => onFailedRetry?.()}
                disabled={!onFailedRetry}
                aria-label="다시 보내기"
              >
                <img src={icons.messager.reload} alt="" width={16} height={16} />
              </button>
              <button
                type="button"
                className={styles.failedActionBtn}
                onClick={() => onFailedDelete?.()}
                disabled={!onFailedDelete}
                aria-label="삭제"
              >
                <img src={icons.messager.closeRed} alt="" width={16} height={16} />
              </button>
            </div>
            <div className={frameBodyClassName}>{bodyEl}</div>
          </div>
          <div className={styles.failedErrorRow} role="alert">
            <img src={icons.messager.failed} alt="" width={18} height={18} />
            <span className={styles.failedErrorText}>{failReason ?? MESSAGE_SEND_ERROR.DEFAULT}</span>
          </div>
        </div>
      );
    }
    return <div className={frameBodyClassName}>{bodyEl}</div>;
  };

  return (
    <div
      className={`${styles.root} ${isMy ? styles.isMy : ""} ${hasContent ? styles.hasContent : ""} ${grouped ? styles.grouped : ""} ${className}${receiptExtraClass}`.trim()}
      data-name={isMy ? "My message" : "Opponent message"}
      data-node-id={isMy ? "40004344:52777" : "40004344:52778"}
      {...(isMy && typeof readReceiptCount === "number" ? { "data-count": readReceiptCount } : {})}
    >
      {!isMy && <OpponentAvatar grouped={grouped} avatarUrl={avatarUrl} />}
      <div className={styles.frame}>
        {((!isMy && senderName) || time) && (
          <div className={styles.metaRow}>
            {!isMy && <span className={styles.senderName}>{senderName}</span>}
            {time && <span className={styles.time}>{time}</span>}
          </div>
        )}
        {hasRenderableBody && renderBodyBlock()}
      </div>
    </div>
  );
}

export default ChatMessage;
